import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import services from '../data/services/servicesData.json';
import workCategories from '../data/portfolio/workCategories';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import ResponsiveImage from '../components/ResponsiveImage';

export function loader({ params }) {
  return { portfolio: services.find(service => service.link === params.serviceId) };
}

export default function ServiceInside() {
  const { serviceId } = useParams();
  const service = services.find(item => item.link === serviceId);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [serviceId]);

  if (!service) {
    return <main className="rg-page rg-service-page rg-container rg-section">
      <Helmet><title>Service not found | Resham Gurung</title></Helmet>
      <h1>Service not found</h1>
      <Link className="rg-service-back" to="/services">Browse my expertise</Link>
    </main>;
  }

  const comparisons = service.beforeAfter || [];
  const fallback = workCategories.find(category => category.slug === (service.number === 20 ? 'wedding' : 'portraits')).images[0];

  return <main className="rg-page rg-service-page">
    <Helmet>
      <title>{service.title} — Before &amp; After | Resham Gurung</title>
      <meta name="description" content={service.description} />
    </Helmet>
    <div className="rg-container">
      <Link className="rg-service-back" to="/services">← My expertise</Link>
      <header className="rg-service-heading">
        <p className="rg-editorial-overline">BEFORE &amp; AFTER</p>
        <h1>{service.title}</h1>
        <p>{service.description}</p>
        <div className="rg-editorial-signature">The difference is in the details.</div>
      </header>
      <section className="rg-service-showcase" aria-labelledby="service-showcase-heading">
        <div className="rg-service-showcase-heading">
          <h2 id="service-showcase-heading">A closer look.</h2>
          {comparisons.length > 0 && <p>Drag the divider to see the transformation.</p>}
        </div>
        {comparisons.length > 0 ? <>
          <div className="rg-service-comparisons">
            {comparisons.map((comparison, index) => <div className="rg-service-frame" key={`${service.link}-${index}`}>
              <BeforeAfterSlider {...comparison} demo={false} alt={comparisons.length > 1 ? `${service.title}, example ${index + 1}` : service.title} />
            </div>)}
          </div>
          {comparisons.some(comparison => comparison.demo) && <p className="rg-service-note">Sample comparison · Service-specific examples coming soon.</p>}
        </> : <>
          <div className="rg-service-frame">
            <ResponsiveImage className="rg-service-still" {...fallback} sizes="(max-width: 768px) calc(100vw - 48px), 1100px" />
          </div>
          <p className="rg-service-note">Sample photograph · Editing examples coming soon.</p>
        </>}
      </section>
      <section className="rg-service-inquiry">
        <p className="rg-editorial-overline">LET’S CREATE SOMETHING BEAUTIFUL</p>
        <h2>Your images, beautifully refined.</h2>
        <p>Tell me about your project, or try a sample edit to see what’s possible.</p>
        <div className="rg-editorial-end-actions">
          <Link to={`/contacts?request=quote&service=${service.link}`}>Request a Quote</Link>
          <Link to={`/contacts?request=sample&service=${service.link}`}>Request a Sample Edit</Link>
        </div>
      </section>
    </div>
  </main>;
}
